@if (calendarInfoDisplay && !gridEventDisplayOverride) {
    <div class="calendar-grid-info">
        <div class="calendar-timer-badge">
            <ms-event-timer
                class="grid-event-timer"
                [calendarInfoDisplay]="calendarInfoDisplay"
                [live]="event.live"
                [start]="event.startDate"
                [scoreboard]="event.scoreboard" />
        </div>
        <div class="calendar-event-info">
            <ng-container *ngTemplateOutlet="defaultTemplate" />
        </div>
    </div>
} @else {
    <ng-container *ngTemplateOutlet="defaultTemplate" />
}

<ng-template #defaultTemplate>
    @if (gridEventDisplayOverride || (isEpcotEnabled && isTwoThreeWayEnabled)) {
        <div class="grid-event-header-wrapper">
            <div class="event-timer-scoreboard-info">
                <ms-event-info
                    [mediaEnabled]="media.enabled"
                    [disableBadges]="true"
                    [showEventTimerInfoSection]="true"
                    [showFixedFooterSection]="false"
                    [event]="event"
                    (click)="eventInfoClick()" />
            </div>
            @for (group of groups; track group.id) {
                <ms-group-header [group]="group" />
            }
        </div>
    }
    <div
        class="grid-event-wrapper"
        [class.has-all-markets]="isAllMarketsLinkEnabled"
        [class.image]="showParticipantImage"
        [class.empty-markets]="empty"
        (click)="eventClick($event)">
        <a
            class="grid-info-wrapper"
            dsTouchClick
            [class.fixed]="media.enabled"
            [vnSpeculativeLink]="eventUrl"
            [href]="eventUrl"
            [msRemoveHref]="shouldRemoveHref">
            <ms-event-detail
                [event]="event"
                [mediaEnabled]="media.enabled"
                [promotedFixtureIdsMap]="promotedFixtureIdsMap"
                [showParticipantImage]="showParticipantImage"
                [showEventTimerInfoSection]="!isTwoThreeWayEnabled && !gridEventDisplayOverride"
                [showParticipantStats]="showParticipantStats"
                [isAllMarketsLinkEnabled]="isAllMarketsLinkEnabled"
                [gameNotes]="gameNotes"
                [showLogoColor]="showLogoColor" />
            <ms-grid-scoreboard [event]="event" />
        </a>
        @if (media.enabled) {
            <ms-event-media [event]="event" [media]="media" [tracking]="tracking" />
        }
        <div class="grid-group-container">
            @if (optionGroupTemplate) {
                <a class="grid-option-group empty" [href]="eventUrl" [vnSpeculativeLink]="eventUrl" [msRemoveHref]="shouldRemoveHref">
                    <ng-container *ngTemplateOutlet="optionGroupTemplate; context: { event: event, hasPreCreated: false }" />
                </a>
            } @else {
                @if (empty) {
                    <a class="grid-option-group empty" [href]="eventUrl" [vnSpeculativeLink]="eventUrl" [msRemoveHref]="shouldRemoveHref">
                        <ms-font-resizer [defaultSize]="1" [maxChars]="emptyChars" [value]="emptyText" />
                        <vn-icon class="icon-alignment" name="theme-right" [size]="gridEventDisplayOverride ? '12' : isEpcotEnabled ? '9' : '13'" />
                    </a>
                } @else {
                    @for (group of groups; track group.id) {
                        <div
                            class="grid-six-pack-wrapper"
                            [class.offline-sibling]="!showSuspendedSelection && emptySiblings(group)"
                            [class.offline-six-pack]="!showSuspendedSelection && emptySixPack(group)">
                            <ms-option-group
                                *rxFor="let childGroup of group.childGroups; trackBy: trackChildGroup"
                                [decorateAttribute]="decorateAttribute"
                                [optionGroup]="groupsMap[childGroup]"
                                [event]="event"
                                [group]="group"
                                [tracking]="tracking"
                                [betDetails]="betDetails" />
                        </div>
                    }
                }
            }
        </div>
        @if (favouriteToggle) {
            <ms-favourite-event-toggle [event]="event" [static]="true" [tracking]="tracking" />
        }
    </div>
    @if (showGameNotes && isAllMarketsLinkEnabled && (!this.gridConfig.isGameNotesLayoutEnabled || isBuildParleyVisible)) {
        <ms-game-notes [gameNotes]="gameNotes" />
    }
    @if (isAllMarketsLinkEnabled) {
        <ms-event-footer
            class="badges-wrapper all-markets"
            [event]="event"
            [mediaEnabled]="media.enabled"
            [promotedFixtureIdsMap]="promotedFixtureIdsMap"
            [eventUrl]="eventUrl"
            [showEventTimerInfoSection]="!isTwoThreeWayEnabled && !gridEventDisplayOverride"
            [showFixedFooterSection]="true"
            [isGameNotesVisible]="showGameNotes && this.gridConfig.isGameNotesLayoutEnabled && !isBuildParleyVisible"
            [gameNotes]="gameNotes" />
    }
</ng-template>
